import { Component } from '@angular/core';
import { ButtonComponent, IconComponent, TileComponent } from '@totalenergiescode/tds-angular';

@Component({
    selector: 'app-informations-and-contact-page',
    imports: [
        TileComponent, ButtonComponent, IconComponent
    ],
    templateUrl: './informations-and-contact-page.component.html',
    styleUrl: './informations-and-contact-page.component.scss'
})
export class InformationsAndContactPageComponent {
}
